import { render, staticRenderFns } from "./TabGallery.vue?vue&type=template&id=a66006ac&scoped=true&"
import script from "./TabGallery.vue?vue&type=script&lang=js&"
export * from "./TabGallery.vue?vue&type=script&lang=js&"
import style0 from "./TabGallery.vue?vue&type=style&index=0&id=a66006ac&prod&lang=scss&"
import style1 from "./TabGallery.vue?vue&type=style&index=1&id=a66006ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66006ac",
  null
  
)

export default component.exports